export default __webpack_public_path__ + "static/karla summers-ecedfabbdb6ce8923c96f5a126c3d463.png";